import {BffTrimData} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

export const getTrimAndVariantForModelId = <TrimModel>(
  trims: BffTrimData<TrimModel>[],
  modelId: string | string[]
): BffTrimData<TrimModel> | undefined => {
  if (Array.isArray(modelId)) {
    return (
      modelId.reduce((trim: BffTrimData<TrimModel> | undefined, id: string) => {
        // Return trim if already found
        if (trim) {
          return trim;
        }
        // Find the trim for the current ID
        return filterFirstTrimOut(trims, id);
      }, undefined) || undefined
    );
  } else {
    return filterFirstTrimOut(trims, modelId);
  }
};

const filterFirstTrimOut = <TrimModel>(
  trims: BffTrimData<TrimModel>[],
  modelId: string
): BffTrimData<TrimModel> | undefined => {
  return trims.find((t: BffTrimData<TrimModel>) =>
    t.modelVariants.find((m: any) => m.id === modelId)
  );
};
